import { useQuery } from '@tanstack/react-query'
import { getEventDetails } from 'services/api/marketing-api'

const useGetEventDetails = (metaEventId) => {
  return useQuery({
    queryKey: ['get-event-details', metaEventId],
    queryFn: () => getEventDetails(metaEventId),
    select: (data) => data?.data,
    retry: 2,
    enabled: !!metaEventId,
  })
}

export default useGetEventDetails
